
<template>
    <div class="row wrapper border-bottom white-bg page-heading mb-2">
        <div class="d-flex align-self-center justify-content-between">
        <h2 class="mt-0">{{ $t("navigations.risk register") }}</h2>
        </div>
    </div>

  <div class="ibox-content">
    <div class="mb-2">
      <div class="form-group row mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0">
            <div class="col-12 col-md-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.riskid") }}</label>
                <input type="text" class="form-control" v-model="riskId" id="riskId" />
                </div>
            </div>
            <div class="col-12 col-md-4 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.riskindicator") }}</label>
                <input type="text" class="form-control" v-model="riskName" id="version" />
                </div>
            </div>
            <div class="col-12 col-md-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.status") }}</label>
                <input type="text" class="form-control" v-model="status" id="version" />
                </div>
            </div>
            <div class="col-12 col-md-2 save_btn w-100 align-self-end"
                type="button"
                @click.prevent="getCriticalProcess()"
            >
                {{ $t("navigations.search") }}
            </div>
        </div>
        </div>
    </div>
    <div class="ibox-content data-grid-container">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">{{ $t('navigations.risk register') }}</h6>
        <div
            class="position-relative cursor-pointer"
            v-if="criticalDataPoints.length != 0"
            @click.prevent="showFilter = !showFilter"
          >
            <img
              src="../../assets/img/filter.png"
              width="17"
              height="17"
              alt="filter table"
            />
            <div class="tool-tip">{{ $t("navigations.filter") }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
        <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
          <div
            class="table-multi-select-dropdown"
            @click.stop="dropdownOpen = !dropdownOpen"
          >
            <div class="selected-options">
              <span>{{ $t("navigations.select columns") }}</span>
            </div>
            <div class="dropdown-arrow"></div>
          </div>
          <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
            <label v-for="(column, index) in getColumns" :key="index">
              <input type="checkbox" v-model="selectedcolumnobj[column]" :value="true" />
              {{ column }}
            </label>
          </div>
        </div>
      </div>

         <template v-if="showTableLoader == true">
            <div class="text-center">
                <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                />
                <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                </div>
            </div>
        </template>
        <template v-else>
             <div class="table-responsive custom-dark-table-wrapper">

                <table class="table table-striped dark-table-head mb-0">
                    <thead>
                        <tr>
                            <th  v-if="selectedcolumnobj['Risk Register ID']"> {{ $t("navigations.risk register id") }}</th>
                            <th  v-if="selectedcolumnobj['Risk Indicator']"> {{ $t("navigations.riskindicator") }}</th>
                            <th  v-if="selectedcolumnobj['Derived From']"> {{ $t("navigations.derivedfrom") }}</th>
                            <th  v-if="selectedcolumnobj['Date Identified']"> {{ $t("navigations.date") }}</th>
                            <th  v-if="selectedcolumnobj['Identified By']"> {{ $t("navigations.verified by") }}</th>
                            <th  v-if="selectedcolumnobj['Responsible Owner']"> {{ $t("navigations.owner") }}</th> 
                            <th  v-if="selectedcolumnobj['Status']"> {{ $t("navigations.status") }}</th>
                            <th  v-if="selectedcolumnobj['Closed Date']"> {{ $t("navigations.closedDate") }}</th>
                            <th  v-if="selectedcolumnobj['Closed By']"> {{ $t("navigations.closedUserEmail") }}</th>

                            <th  v-if="selectedcolumnobj['Mitigation Plan']"> {{ $t("navigations.mitigationplan") }}</th>
                            <th  v-if="selectedcolumnobj['Expected Outcome']"> {{ $t("navigations.expectedOutcome") }}</th>  
                            <th  v-if="selectedcolumnobj['Resource Need']"> {{ $t("navigations.resourceNeed") }}</th>  
                            <th  v-if="selectedcolumnobj['Evidence Upload']"> {{ $t("navigations.evidenceUpload") }}</th>  
                            <th  v-if="selectedcolumnobj['Resolved Date']"> {{ $t("navigations.resolvedDate") }}</th> 
                            <th  v-if="selectedcolumnobj['Lesson Learned']"> {{ $t("navigations.lessonLearned") }}</th> 
                            <th  v-if="selectedcolumnobj['Comments']"> {{ $t("navigations.comments") }}</th>  
                            <th  v-if="selectedcolumnobj['Data Scope']"> {{ $t("navigations.dataScope") }}</th>
                            <th class="text-center"> {{ $t("navigations.view") }}</th>   
                        </tr>
                    </thead>
                    <tbody class="custom-table-wrapper">
                        <tr v-for="item in criticalDataPoints" :key="item.id">
                            <td  v-if="selectedcolumnobj['Risk Register ID']"> {{ item.riskId }}</td>
                            <td  v-if="selectedcolumnobj['Risk Indicator']"> {{ item.riskName }}</td>
                            <td  v-if="selectedcolumnobj['Derived From']"> {{ item.derivedFrom }}</td>
                            <td  v-if="selectedcolumnobj['Date Identified']"> {{ filter(item.CreatedAt) }}</td>
                            <td  v-if="selectedcolumnobj['Identified By']"> {{ item.CreatedUserEmail }}</td>
                            <td  v-if="selectedcolumnobj['Responsible Owner']"> {{ item.responsibleOwner ? item.responsibleOwner[0]:'' }}</td>
                            <td  v-if="selectedcolumnobj['Status']"> {{ item.status }}</td>
                            <td  v-if="selectedcolumnobj['Closed Date']"> {{ filter(item.closedDate) }}</td>
                            <td  v-if="selectedcolumnobj['Closed By']"> {{ item.closedUserEmail }}</td>

                            <td  v-if="selectedcolumnobj['Mitigation Plan']"> 
                              <div>
                            <span v-if="!showMoreMitigation[item.id]">
                      {{ item.mitigationPlan ? item.mitigationPlan.substring(0, 30) : "" }}
                      <span
                        class="cursor-pointer more-block"
                        v-if="item.mitigationPlan && item.mitigationPlan.length > 30"
                        @click="showMoreMitigation[item.id] = true"
                        >...More</span
                      >
                    </span>
                    <span class="breakWord" v-else>
                      {{ item.mitigationPlan }}
                      <span
                        class="cursor-pointer more-block"
                        @click="showMoreMitigation[item.id] = false"
                        >Show Less</span
                      >
                    </span> </div>
                            </td>
                            <td  v-if="selectedcolumnobj['Expected Outcome']"> {{ item.expectedOutcome }}</td>
                            <td  v-if="selectedcolumnobj['Resource Need']"> {{ item.resourceNeed }}</td>                            
                            <td v-if="selectedcolumnobj['Evidence Upload']"> 
                            <span v-for="(evidence, index) in item.evidenceUpload" :key="index">
                                {{ evidence }}<span v-if="index !== item.evidenceUpload.length - 1">, </span>
                            </span>
                            </td>
                            
                            <td  v-if="selectedcolumnobj['Resolved Date']"> {{ filter(item.resolvedDate) }}</td>
                            <td  v-if="selectedcolumnobj['Lesson Learned']"> {{ item.lessonLearned }}</td>
                            <td  v-if="selectedcolumnobj['Comments']"> {{ item.comments }}</td>
                            <td  v-if="selectedcolumnobj['Data Scope']"> {{ item.dataScope }}</td>
                            <td class="text-center"> 
                                <div class="position-relative cursor-pointer"
                                     @click.prevent="CreateRiskClicked(item.id)">
                                    <i class="fa fa-eye edit-delete"></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
  </div>

<TaskListModal
    v-if="showCriricalPopUp"
    :criticalInfo="selectedCriticalDP"
    formPage="Task list data"
    @closeModal="closeCriticalDataPopup"
  />
  <manageRiskRegisterModal 
    v-if="showRiskRegisterModal"
    :riskRegId="riskRegisterId"
    @closeModal="closeRiskReg"
  />

</template>

<script src="./RiskRegister.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.breakWord {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
.more-block {
  color: blue;
  cursor: pointer;
}
</style>